import ReactRailsUJS from "@shared/polyfill/react_ujs";
import { clientInitCoralogix } from "@shared/utils/clientInitCoralogix/clientInitCoralogix.client";
import { hello } from "@shared/utils/hello";
import { initFsAnalyticsUnauth } from "@shared/utils/initFsAnalytics/initFsAnalytics";
import { initSentry } from "@shared/utils/initSentry/initSentry";
import { isSentryTunnelEnabled } from "@shared/utils/initSentry/isSentryTunnelEnabled/isSentryTunnelEnabled";

initFsAnalyticsUnauth();

const componentRequireContext = require.context("@unauthenticated/signupSignin", false);

initSentry({
  enableRouterInstrumentation: true,
  tracesSampleRate: 0.01,
  enableSentryTunnel: isSentryTunnelEnabled(),
});
clientInitCoralogix({
  sessionConfig: {
    sessionSampleRate: 0,
    alwaysTrackSessionsWithErrors: false,
  },
});

ReactRailsUJS.useContext(componentRequireContext);
hello();
